import React from 'react'
import {Routes,Route} from "react-router-dom"
import Bookmark from '../components/Bookmark'
import Form from '../components/Form'
import Navbar from '../components/Navbar'
import Note from '../components/Note'

function AllRoutes() {
  return (
    <div>
      <Navbar/>
      <Routes>
        <Route path='/' element={<Form/>}/>
        <Route path="/note" element={<Note/>} />
        <Route path ="/bookmark" element={<Bookmark/>}/>
        

 

      </Routes>


    </div>
  )
}

export default AllRoutes